import type { JSX } from "react";

import { CATEGORIES_TO_DISPLAY } from "app/services/category/userCustomCategoryService";

import { ScrollAreaWrap } from "../utils";

interface ITabPanelItemsProps {
    items: any[];
    isShared?: boolean;
    createListItem: (enforceIcon?: boolean, editable?: boolean) => (item: any) => JSX.Element;
    enforceIcon?: boolean;
}

export const TabPanelItems = ({
    items,
    isShared = false,
    createListItem,
    enforceIcon = false,
}: ITabPanelItemsProps) => {
    const itemsToRender = isShared ? items.slice(0, CATEGORIES_TO_DISPLAY) : items;
    return <ScrollAreaWrap>{itemsToRender.map(createListItem(enforceIcon, !isShared))}</ScrollAreaWrap>;
};
